import { PageContainer, PageTabs } from '@if/mui'
import DisbursementHistory from '@src/components/Disburse/DisbursementHistory'
import PendingLenderPaymentSelection from '@src/components/Disburse/PendingLenderPaymentSelection'
import { useTranslation } from 'react-i18next'

// Tab values double as URL segments (`/:company/disbursements/:tab?`); the first one owns the bare path.
const DISBURSE_TAB = 'disburse'
const HISTORY_TAB = 'history'

const DisbursePage = () => {
  const { t } = useTranslation()

  return (
    <PageContainer title={t('disburse.title')}>
      <PageTabs
        label={t('disburse.tabs.label')}
        tabs={[
          { value: DISBURSE_TAB, label: t('disburse.tabs.disburse'), content: <PendingLenderPaymentSelection /> },
          { value: HISTORY_TAB, label: t('disburse.tabs.history'), content: <DisbursementHistory /> },
        ]}
      />
    </PageContainer>
  )
}

export default DisbursePage
